"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHeartAssistSystemTherapy = createHeartAssistSystemTherapy;
const events_1 = require("../../../events");
const heartAssistSystemTherapy_1 = require("../../../forms/htx/current-cardiological-state/heartAssistSystemTherapy");
const queries_1 = require("../queries");
const messages = {
    heartAssistSystem: {
        id: "dashboard.heart_assist_system",
        defaultMessage: "Mechanikus keringéstámogatás"
    },
    deviceType: {
        id: "dashboard.heart_assist_system.device_type",
        defaultMessage: "Eszköz típusa"
    },
    deviceName: {
        id: "dashboard.heart_assist_system.device_name",
        defaultMessage: "Eszköz neve"
    }
};
function createHeartAssistSystemTherapy({ formatMessage, formatMessageMap, formatDate }, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.queries.heartAssistSystemTherapy);
    if (event === undefined) {
        return undefined;
    }
    const { value, timestamp, sid, origin } = event;
    if (value.mcs === heartAssistSystemTherapy_1.Mcs.NO) {
        return undefined;
    }
    const attachemnts = (0, events_1.mapEventsToAttachments)(event);
    const lists = value.devices.map(device => {
        const items = [];
        items.push({
            type: "list-item",
            label: formatMessage(messages.deviceType),
            value: formatMessageMap(heartAssistSystemTherapy_1.devicesTypeMessages, device.type)
        });
        if (device.name !== undefined) {
            items.push({
                type: "list-item",
                label: formatMessage(messages.deviceName),
                value: device.name
            });
        }
        for (const { type, date } of device.complications) {
            items.push({
                type: "list-item",
                label: formatDate(date, {
                    year: "numeric",
                    month: "numeric",
                    day: "numeric"
                }),
                value: formatMessageMap(heartAssistSystemTherapy_1.complicationsTypeMessages, type)
            });
        }
        return {
            type: "list",
            attachemnts,
            items,
            timestamp,
            sid,
            origin
        };
    });
    return {
        type: "group",
        variant: "dark",
        label: formatMessage(messages.heartAssistSystem),
        content: lists
    };
}
